<div class="header flex items-center">
  <!-- Left Section: Header Text -->
  <div class="flex items-center flex-shrink-0 min-w-0">
    <span class="truncate heading-md " data-testid="page-header-title">{{ title }}</span>
  </div>

  <!-- Center Section: Cache refresh metadata - Hidden on smaller screens -->
  <div class="hidden xl:flex justify-center flex-grow w-full">
    <ng-container *ngIf="isRefreshing">
      <div class="flex items-center gap-4 text-base">
        <span class="refreshing-text">refreshing cache...</span>

        @for (indicator of syncIndicators; track indicator.icon) {
          <div class="asset-sync-indicator">
            <div class="icon-spinner-container">
              <mat-icon class="sync-icon">{{ indicator.icon }}</mat-icon>
              <mat-spinner class="cache-spinner" [diameter]="48"></mat-spinner>
            </div>
            <span class="asset-count">{{ indicator.count$ | async }}</span>
          </div>
        }
      </div>
    </ng-container>
  </div>

  <div class="flex items-center gap-4">
    <!-- Last Updated timestamp - show when not refreshing -->
    <ng-container *ngIf="!isRefreshing && cacheLastUpdated">
      <span class="!text-sm !font-normal text-gray-600 whitespace-nowrap">
        Cache last updated: {{ cacheLastUpdated }}
      </span>
    </ng-container>

    <ng-content></ng-content>
  </div>
</div>
